import { render, staticRenderFns } from "./AddAlbaranPage.vue?vue&type=template&id=5abe41ce&scoped=true"
import script from "./AddAlbaranPage.vue?vue&type=script&lang=js"
export * from "./AddAlbaranPage.vue?vue&type=script&lang=js"
import style0 from "./AddAlbaranPage.vue?vue&type=style&index=0&id=5abe41ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe41ce",
  null
  
)

export default component.exports